import { trace } from '@opentelemetry/api';

import { jsonFetcher } from '@flywire/internal-components/utils/fetcher/fetcher';
import { buildAttributes } from '@flywire/internal-components/utils/otelTracing';

import { ENDPOINTS } from './api/endpoints';

const tracer = trace.getTracer('flywire-js-sdk-manual-instrumentation');

export const recordEvent = async (eventName: string, attributes?: object, sessionId?: string) => {
  const frontendKey = window.FLYWIRE_FE_KEY;
  if (sessionId && frontendKey) {
    await logToBackend(sessionId, { eventName, ...attributes }, frontendKey);
  }

  tracer.startActiveSpan(eventName, span => {
    span.setAttributes(buildAttributes(attributes || {}));
    span.end();
  });
};

const logToBackend = async (sessionId: string, attributes: object, frontendKey: string) => {
  try {
    await jsonFetcher(`${ENDPOINTS.fetchSession}/${sessionId}/log`, {
      method: 'POST',
      noResponse: true,
      body: JSON.stringify({ severity: 'info', provider: 'flywire-js-sdk', ...attributes }),
      headers: { X_FRONTEND_API_KEY: frontendKey }
    });
  } catch {
    console.log('There was an error sending the telemetry event');
  }

  return undefined;
};
